import axios, { AxiosStatic } from 'axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { dispatch, listen } from '../app/support/utils';

// Declare all the properties attached to Window
declare global {
    interface Window {
        axios: AxiosStatic
        Pusher: typeof Pusher
        Echo: Echo<"reverb">
        listen: typeof listen
        dispatch: typeof dispatch
    }
}

// Retrieve the page csrf token if available
// const CSRF_TOKEN = csrfToken();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios = axios;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

if (import.meta.env.DEV) {
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: 'https' === (import.meta.env.VITE_REVERB_SCHEME ?? 'https'),
        enabledTransports: ['ws', 'wss'],
    });
    dispatch('echo-started');
}

window.listen = listen;
window.dispatch = dispatch;
